export default "__VITE_ASSET__9bedac22__"